/**
 * @generated SignedSource<<c4391853de725efd12249785452adbc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type acquisitionConfigAppConfigQuery$variables = {};
export type acquisitionConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null;
  } | null;
};
export type acquisitionConfigAppConfigQuery = {
  response: acquisitionConfigAppConfigQuery$data;
  variables: acquisitionConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "acquisition"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "acquisitionConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"acquisition\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "acquisitionConfigAppConfigQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"acquisition\"})"
      }
    ]
  },
  "params": {
    "cacheID": "d34b77deddc5addc0bdc442037eb3812",
    "id": null,
    "metadata": {},
    "name": "acquisitionConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query acquisitionConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"acquisition\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b6d1aadebb4a707abaf178b27e5716e";

export default node;
